import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import StockItemForm from "../../components/Forms/StockItemForm";
import { getMyUser } from "../../store/session/selectors";
import { PermissionEnum } from "../../models";
import { StockEntity } from "../../store/entities/state";
import { isSubmitting, getChangeLog, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { entityEditionCancel, updateEntity, deleteEntity, loadEntityChangeLog, updateChangingEntity } from "../../store/entities/actions";
import { updateStockAsync, deleteStockAsync, getStockChangeLogAsync } from "../../ajax/requests";
import { StockItemFormDispatchProps, StockItemFormStateProps } from "../../components/Forms/StockItemForm/StockItemForm";

const canEdit = (state: ApplicationState) => getMyUser(state)?.permissions.some(p => p === PermissionEnum.Administrator) || false;

export interface StockItemFormProps {
    data: StockEntity,
}

const mapStateToProps = (state: ApplicationState, ownProps: StockItemFormProps): StockItemFormStateProps => ({
    type: 'edit',
    canEdit: canEdit(state),
    data: getChangingValue(state, 'stock') as StockEntity || ownProps.data,
    hasChanged: getChangingState(state, 'stock'),
    isSubmitting: isSubmitting('stock')(state),
    changeLog: getChangeLog(state, 'stock', ownProps.data.id),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: StockItemFormProps): StockItemFormDispatchProps => ({
    onChange: (data: StockEntity) => dispatch(updateChangingEntity('stock', data)),
    onCancel: () => dispatch(entityEditionCancel('stock')),
    onSave: (data: StockEntity) => dispatch(updateEntity('stock', data, s => updateStockAsync(s.id, s))),
    onDelete: () => dispatch(deleteEntity('stock', ownProps.data.id, d => deleteStockAsync(d))),
    onLoad: () => {
        dispatch(loadEntityChangeLog('stock', ownProps.data.id, () => getStockChangeLogAsync(ownProps.data.id)));
    },
});

export default connect<StockItemFormStateProps, StockItemFormDispatchProps, StockItemFormProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(StockItemForm as any);
